var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnblockUser = function SvgUnblockUser(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-20": 17,
    "data-width-24": 20,
    viewBox: "0 0 20.8 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M13.013 12.942C11.904 12.365 10.49 12 8.7 12c-6.4 0-8 4.667-8 7h11.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.45 9.5a4.75 4.75 0 1 1 0-9.5 4.75 4.75 0 0 1 0 9.5m0-8a3.25 3.25 0 1 0 3.25 3.25A3.26 3.26 0 0 0 8.45 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M15.7 15v-1.564c0-1.915 3-1.915 3 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.2,
    d: "M15.2 15.6h4a.9.9 0 0 1 .9.9v2a.9.9 0 0 1-.9.9h-4a.9.9 0 0 1-.9-.9v-2a.9.9 0 0 1 .9-.9Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnblockUser);
export default ForwardRef;